import { get } from 'svelte/store';

import { PhoneCell } from '../store/index';

import { getCookie } from '@/utils/cookie';

/** 广告转化：登录成功上报 5002；5001 由 HTML adv 初始化上报 */
export const CREDIT_CARD_LOGIN_MEDIA_EVENT = 5002;

export const mediaEventUp = (
    sceneId: number,
    data?: { [key: string]: any }
) => {
    try {
        window.adv?.mediaEventUp(sceneId, {
            data
        });
    } catch (error) {
        console.error(error);
    }
};

export const getMediaEvent2006Ext = (ext: Record<string, unknown> = {}) => ({
    mobile: getCookie('cell') || get(PhoneCell) || '',
    uid: getCookie('uid') || '',
    ticket: getCookie('ticket') || '',
    ...ext
});

// 使用闭包跟踪执行状态
const createOnceTracker = () => {
    const executed = new Set<number>();

    return (eventId: number): boolean => {
        if (executed.has(eventId)) {
            return false;
        }

        executed.add(eventId);

        return true;
    };
};

// 跟踪器实例
const trackOnce = createOnceTracker();

export const mediaEventUpOnce = async (scene: number, ext?: any) => {
    // 如果已执行过则直接返回
    if (!trackOnce(scene)) {
        return;
    }

    // 执行原始埋点
    return mediaEventUp(scene, ext);
};
